<template>
  <div class="book-container">
    <slick
      ref="slick"
      :options="slickOptions"
      >
      <img src="/static/book/00.jpg" alt="食事ブック">
      <img src="/static/book/01.jpg" alt="食事ブック">
      <img src="/static/book/02.jpg" alt="食事ブック">
      <img src="/static/book/03.jpg" alt="食事ブック">
      <img src="/static/book/04.jpg" alt="食事ブック">
      <img src="/static/book/05.jpg" alt="食事ブック">
      <img src="/static/book/06.jpg" alt="食事ブック">
      <img src="/static/book/07.jpg" alt="食事ブック">
      <img src="/static/book/08.jpg" alt="食事ブック">
      <img src="/static/book/09.jpg" alt="食事ブック">
      <img src="/static/book/10.jpg" alt="食事ブック">
      <img src="/static/book/11.jpg" alt="食事ブック">
      <img src="/static/book/12.jpg" alt="食事ブック">
      <img src="/static/book/13.jpg" alt="食事ブック">
      <img src="/static/book/14.jpg" alt="食事ブック">
      <img src="/static/book/15.jpg" alt="食事ブック">
      <img src="/static/book/16.jpg" alt="食事ブック">
      <img src="/static/book/17.jpg" alt="食事ブック">
      <img src="/static/book/18.jpg" alt="食事ブック">
      <img src="/static/book/19.jpg" alt="食事ブック">
      <img src="/static/book/20.jpg" alt="食事ブック">
      <img src="/static/book/21.jpg" alt="食事ブック">
      <img src="/static/book/22.jpg" alt="食事ブック">
    </slick>
  </div>
</template>

<script>
import Slick from 'vue-slick'
import 'slick-carousel/slick/slick.css'

export default {
  name: 'Book',
  components: {
    Slick
  },
  data() {
    return {
      slickOptions: {
        slidesToShow: 1,
        swipe: true,
        arrows: true,
        prevArrow: '<button class="slide-arrow prev-arrow"></button>',
        nextArrow: '<button class="slide-arrow next-arrow"></button>'
      }
    }
  },
  methods: {
    next() {
      this.$refs.slick.next()
    },
    prev() {
      this.$refs.slick.prev()
    // },
    // reInit() {
    //   this.$nextTick(() => {
    //     this.$refs.slick.reSlick()
    //   })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.book-container{
  max-width: 500px;
  margin: auto;
}

</style>



// WEBPACK FOOTER //
// src/components/Book.vue